// project imports
import * as actionTypes from "./actions";

export const initialState = {
  data_collections: [],
  analysis_collections: [],
};

// CUSTOMIZATION REDUCER

const returnCollectionsReducer = (state = initialState, action) => {
  let value;
  switch (action.type) {
    case actionTypes.RETURN_DATA_COLLECTIONS:
      value = action.value;
      return {
        ...state,
        value,
      };
    case actionTypes.ANALYSIS_COLLECTIONS:
      value = action.value;
      return {
        ...state,
        value,
      };
    default:
      return state;
  }
};

export default returnCollectionsReducer;
